<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbItems">
    <v-card>
      <vue-card-title
        :title="currentView + ' Clients'"
        :subtitle="'Refer to the following information on all the clients.'"
        :icon="$getIcon('mdiClipboardTextOutline')"
      >
        <template slot="actions">
          <!-- <v-btn-toggle v-model="currentView" mandatory class="elevation-0">
            <v-btn small class="text-capitalize" value="b2b">
              <v-icon v-text="$getIcon('mdiBriefcase')" class="mr-1"> </v-icon>
              B2B
            </v-btn>
            <v-btn disabled small class="text-capitalize" value="b2c">
              <v-icon v-text="$getIcon('mdiAccount')" class="mr-1"> </v-icon>
              B2C
            </v-btn>
          </v-btn-toggle> -->
          <v-btn
            class="indigo accent-2 white--text text-capitalize my-0"
            small
            @click="clientForm = true"
          >
            Create Client
          </v-btn>
          <v-btn
            class="indigo accent-2 white--text text-capitalize my-0"
            small
            @click="importDialog = true"
          >
            Import Client
          </v-btn>
          <v-dialog v-model="importDialog" max-width="500px">
            <v-card>
              <vue-card-title
                title="Client Import"
                subtitle="Please Select Json File"
                :icon="$getIcon('mdiUpload')"
              ></vue-card-title>
              <v-divider></v-divider>
              <v-card-text class="px-3 mt-5 mb-0 pb-0">
                <v-file-input
                  type="file"
                  label="File input"
                  dense
                  @change="processFile($event)"
                ></v-file-input>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="importDialog = false">
                  Close
                </v-btn>
                <v-btn
                  color="primary"
                  depressed
                  @click="submitImport()"
                  :disabled="loading"
                  :loading="loading"
                >
                  Import
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn
            icon
            class="grey--text ma-0"
            @click="showFilters = !showFilters"
          >
            <v-icon small v-text="$getIcon('mdiFilterVariant')"></v-icon>
          </v-btn>
        </template>
      </vue-card-title>
      <v-divider></v-divider>
      <v-slide-y-transition>
        <v-row v-if="showFilters" class="mx-2">
          <v-col cols="12" md="3">
            <v-text-field
              v-model="appliedFilters.search"
              label="Search By Client Name"
              :prepend-inner-icon="$getIcon('mdiMagnify')"
              clearable
              @keypress.enter="fetchDataTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="appliedFilters.associated_users__crm_user"
              label="Filter By User"
              :items="creList.results"
              :prepend-inner-icon="$getIcon('mdiAccountOutline')"
              item-text="name"
              item-value="id"
              class="mx-2"
              cache-items
              clearable
              @focus="this.loadCre"
              @change="fetchDataTable"
            ></v-autocomplete>
          </v-col>
          <v-col md="3" cols="12">
            <v-select
              :prepend-inner-icon="$getIcon('mdiTransitConnection')"
              v-model="appliedFilters.source_medium_direction"
              label="Filter by Medium Direction"
              :items="['All', 'Inbound', 'Outbound']"
              @change="fetchDataTable"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <vue-auto-complete
              v-model="appliedFilters.source"
              label="Filter By Source"
              :endpoint="sourceEndpoint"
              :prepend-inner-icon="$getIcon('mdiInformationOutline')"
              item-text="name"
              item-value="slug"
              @input="fetchDataTable"
            ></vue-auto-complete>
          </v-col>
          <v-col cols="12" md="3">
            <vue-auto-complete
              v-model="appliedFilters.b2b__industry__name"
              label="Filter By Industry"
              :endpoint="industryEndpoint"
              :prepend-inner-icon="$getIcon('mdiInformationOutline')"
              item-text="name"
              item-value="slug"
              @input="fetchDataTable"
            ></vue-auto-complete>
          </v-col>
        </v-row>
      </v-slide-y-transition>
      <v-data-table
        :items="fetchedResults"
        :headers="headers"
        :page.sync="pagination.page"
        :loading="loading"
        :items-per-page.sync="pagination.rowsPerPage"
        :footer-props="footerProps"
        :server-items-length="pagination.totalItems"
      >
        <template v-slot:item="props">
          <tr>
            <td width="20%" class="py-2">
              <div class="d-inline-flex align-center">
                <div class="mr-2">
                  <v-avatar tile :size="50">
                    <v-img
                      :src="
                        props.item.logo
                          ? props.item.logo
                          : require(`@/static/images/organization/default-logo.jpg`)
                      "
                      style="border: 2px solid #efefef;"
                    >
                    </v-img>
                  </v-avatar>
                </div>
                <div>
                  <a
                    class="link blue--text font-weight-bold"
                    @click="viewClientDetail(props.item)"
                  >
                    {{ props.item.name }}
                  </a>
                  <span
                    class="is_blocked px-2 float-right"
                    v-if="props.item.is_blocked"
                    >Blocked!</span
                  >
                  <p class="grey--text">
                    {{ props.item.email || "N/A" }}<br />
                    <a
                      v-if="props.item.reference_id"
                      class="link grey--text font-weight-bold"
                    >
                      #{{ props.item.reference_id }}
                    </a>
                  </p>
                </div>
              </div>
            </td>
            <td>{{ props.item.b2b.industry_name || "N/A" }}</td>
            <td>
              {{
                `${props.item.address.city || ""}${
                  props.item.address.country ? " " : ""
                }${props.item.address.country || ""}` || "N/A"
              }}
            </td>
            <td>
              <div v-if="props.item.associated_users.length">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-avatar :size="35" v-on="on">
                      <v-img
                        :src="
                          props.item.associated_users.length
                            ? props.item.associated_users[0].crm_user_info
                                .picture
                            : require(`@/static/images/info/user-default.png`)
                        "
                        alt="CRE avatar"
                      ></v-img>
                    </v-avatar>
                  </template>
                  {{
                    props.item.associated_users.length
                      ? props.item.associated_users[0].crm_user_info.full_name
                      : "N/A"
                  }}
                </v-tooltip>
              </div>
              <div v-else class="red--text font-weight-bold">
                N/A
              </div>
            </td>
            <td class="text-center">
              {{ props.item.source_medium_direction || "N/A" }}
            </td>
            <td class="text-center">
              {{ (props.item.source && props.item.source.name) || "N/A" }}
            </td>
            <td class="text-center">
              {{ props.item.created_at.slice(0, 10) }}
            </td>
            <td class="text-center">
              <v-menu offset-y left transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                  <v-btn small text icon v-on="on">
                    <v-icon v-text="$getIcon('mdiDotsVertical')"></v-icon>
                  </v-btn>
                </template>
                <v-list dense class="pa-0">
                  <v-list-item
                    @click="viewClientDetail(props.item)"
                    class="pointer"
                  >
                    <v-list-item-title>
                      <v-icon
                        disabled
                        small
                        color="grey"
                        v-text="$getIcon('mdiEye')"
                      ></v-icon>
                      <span
                        class="ml-1 grey--text text--darken-2"
                        v-text="'View Details'"
                      ></span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addLog(props.item.slug)" class="pointer">
                    <v-list-item-title>
                      <v-icon
                        disabled
                        small
                        color="grey"
                        v-text="$getIcon('mdiCommentMultiple')"
                      ></v-icon>
                      <span
                        class="ml-1 grey--text text--darken-2"
                        v-text="'Add Log'"
                      ></span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="
                      (selectedClientData = props.item) && (clientForm = true)
                    "
                    class="pointer"
                  >
                    <v-list-item-title>
                      <v-icon
                        disabled
                        small
                        color="grey"
                        v-text="$getIcon('mdiCommentMultiple')"
                      ></v-icon>
                      <span
                        class="ml-1 grey--text text--darken-2"
                        v-text="'Update'"
                      ></span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="assignUser(props.item)" class="pointer">
                    <v-list-item-title>
                      <v-icon
                        disabled
                        small
                        color="grey"
                        v-text="$getIcon('mdiEye')"
                      ></v-icon>
                      <span
                        class="ml-1 grey--text text--darken-2"
                        v-text="
                          props.item.associated_users.length
                            ? 'Update Assigned User'
                            : 'Assign User'
                        "
                      ></span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-icon
                small
                color="grey"
                v-text="$getIcon('mdiEye')"
                @click="informationView(props.item)"
              ></v-icon>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <vue-data-table-no-data :loading="loading"></vue-data-table-no-data>
        </template>
      </v-data-table>
      <v-navigation-drawer
        width="500"
        v-model="clientAssignedUserForm"
        right
        temporary
        fixed
        clipped
      >
        <template v-slot:prepend>
          <v-card flat
            ><vue-card-title
              :title="cardTitleAssignedUser"
              :subtitle="
                'Fill up the following form to action on client assigned user.'
              "
              dark
              :icon="$getIcon('mdiFileDocumentEdit')"
              closable
              @close="clientAssignedUserForm = false"
            >
            </vue-card-title>
            <v-divider></v-divider>
          </v-card>
        </template>
        <client-assign-user-form
          v-if="clientAssignedUserForm"
          :action-data="selectedClientAssignedUserData"
          @clientAssignedUserFormResponse="
            (clientAssignedUserForm = false), fetchDataTable()
          "
          :client-slug="clientSlug"
        >
        </client-assign-user-form>
      </v-navigation-drawer>
    </v-card>
    <div>
      <!-- Client Details -->
      <div>
        <v-dialog
          v-model="viewClientDetailComponent"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card tile>
            <vue-card-title
              :title="`Client Detail`"
              :subtitle="'Review client detailed information.'"
              :icon="$getIcon('mdiClipboardTextOutline')"
              closable
              @close="viewClientDetailComponent = false"
            >
            </vue-card-title>
            <v-divider></v-divider>
            <v-card-text class="">
              <client-detail
                :client-detail="clientDetail || {}"
              ></client-detail>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showInformationView" width="700px">
          <information
            v-if="showInformationView"
            :slug="clientSlug"
            @close-view="showInformationView = false"
          ></information>
        </v-dialog>
      </div>
      <!-- / Client Details -->
      <!-- Client Form -->

      <v-navigation-drawer
        width="900"
        v-model="clientForm"
        right
        temporary
        fixed
        clipped
      >
        <template v-slot:prepend>
          <v-card tile>
            <vue-card-title
              :title="cardTitle"
              dark
              :subtitle="'Fill up the following form to action on client data.'"
              :icon="$getIcon('mdiFileDocumentEdit')"
              closable
              @close="clientForm = false"
            >
            </vue-card-title>
            <v-divider></v-divider>
          </v-card>
        </template>
        <client-form
          v-if="selectedClientData && clientForm"
          :action-data="selectedClientData"
          :client-type="currentView"
          @close="clientForm = false"
          @clientFormResponse="formSuccess"
        >
        </client-form>
      </v-navigation-drawer>
      <!-- / Client Form -->
    </div>
  </vue-page-wrapper>
</template>
<script>
import DataTableMixin from "@/mixins/dataTableMixin";
import ClientForm from "@/components/crm/client/forms/ClientForm";
import ClientDetail from "@/components/crm/action_board/ClientDetail";
import ClientAssignUserForm from "@/components/crm/client/forms/ClientAssignUserForm";
import cancelRequestMixin from "@/mixins/cancelRequestMixin";
import Information from "@/components/crm/client/components/Information";
export default {
  components: {
    ClientForm,
    ClientDetail,
    ClientAssignUserForm,
    Information,
  },
  mixins: [DataTableMixin, cancelRequestMixin],
  data() {
    return {
      htmlTitle: "Clients",
      breadCrumbItems: [{ text: "Clients", disabled: true }],
      clientSlug: "",
      // paginationMixin
      fetchAPI: "/api/v1/crm/clients/?b2b__isnull=False",
      // form
      clientAssignedUserForm: false,
      clientForm: false,
      importDialog: false,
      viewClientDetailComponent: false,
      clientDetail: {},
      selectedClientData: {},
      cardTitle: "",
      // - form
      showFilters: false,
      currentView: "b2b",
      clientFetchAPI: {
        b2b: "/api/v1/crm/clients/?b2b__isnull=False",
        b2c: "/api/v1/crm/clients/?b2c__isnull=False",
      },
      listView: true,
      headers: [
        {
          text: "Client Name",
          full_text: "Client Name",
          value: "name",
          width: "20%",
          sortable: false,
        },
        { text: "Industry", width: "15%", sortable: false },
        { text: "Address", width: "20%", sortable: false },
        { text: "User", sortable: false },
        { text: "Medium Direction", align: "center", sortable: false },
        { text: "Source", align: "center", sortable: false },
        { text: "Registered At", align: "center", sortable: true },
        { text: "Actions", sortable: false, align: "center" },
      ],
      rowsPerPageItems: [7, 10, 20, 30, 40, 50],
      loading: false,
      selectedClientAssignedUserData: {},
      search: "",
      appliedFilters: {
        search: "",
        associated_users__crm_user: null,
        organization__slug: this.$store.state.shell.currentOrganizationId,
        source_medium_direction: "All",
        source: "",
        b2b__industry__name: "",
      },
      sourceEndpoint: "/api/v1/crm/client-source/choices/?fields=name,slug",
      industryEndpoint: `/api/v1/crm/industry/choices/?fields=name,id&?organization__slug=${this.$store.state.shell.currentOrganizationId}`,
      creList: [],
      showInformationView: false,
    };
  },
  computed: {
    searchLabel() {
      return "Search for " + this.currentView + " clients...";
    },
    cardTitleAssignedUser() {
      return Object.keys(this.selectedClientAssignedUserData).length
        ? "Update Client Assigned User"
        : "Create Client Assigned User";
    },
  },
  watch: {
    currentView(newVal) {
      this.fetchAPI = this.clientFetchAPI[newVal];
      this.fetchDataTable();
    },
    clientForm(newVal) {
      if (Object.keys(this.selectedClientData).length > 0 && newVal) {
        this.cardTitle = "Update Client";
      } else {
        this.selectedClientData = {};
        this.cardTitle = "Create Client";
      }
    },
    clientDetail(newVal) {
      this.clientDetail = newVal;
    },
  },
  methods: {
    async fetchDataTable() {
      this.checkRequest();
      const filters = JSON.parse(JSON.stringify(this.appliedFilters));
      if (!filters.associated_users__crm_user) {
        delete filters.associated_users__crm_user;
      }
      filters.search = filters.search || "";
      filters.source_medium_direction =
        filters.source_medium_direction === "All"
          ? ""
          : filters.source_medium_direction;
      filters.source__slug = filters.source;
      const extraParams = {
        ...filters,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage,
        ordering: this.pagination.descending
          ? this.pagination.sortBy
          : "-" + this.pagination.sortBy,
      };
      const URLSearchParams = this.convertToURLSearchParams(extraParams);
      this.loading = true;
      this.$axios
        .$get(this.fetchAPI, {
          params: URLSearchParams,
          cancelToken: this.axiosSource.token,
        })
        .then((response) => {
          this.clearOldRequest("Success");
          this.loadDataTable(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formSuccess() {
      this.fetchDataTable();
    },
    viewClientDetail(clientDetail) {
      this.$router.push({
        name: "clients-clientslug",
        params: { clientSlug: clientDetail.slug },
      });
    },
    humanizeDate(timeStamp) {
      return this.$dayjs(timeStamp).fromNow();
    },
    getLastCommunicated(timeStamp) {
      if (!timeStamp) return { color: "red--text", text: "N/A" };
      const daysObject = {
        30: "green--text",
        60: "blue--text",
      };
      for (const day in daysObject) {
        if (
          this.$dayjs(timeStamp).isAfter(this.$dayjs().subtract(day, "days"))
        ) {
          return {
            color: daysObject[day],
            text: this.humanizeDate(timeStamp),
          };
        }
      }
      return { color: "red--text", text: this.humanizeDate(timeStamp) };
    },
    getAmount(amount) {
      if (amount) {
        return amount.toLocaleString();
      } else return 0;
    },
    addLog(clientSlug) {
      this.$router.push(`/client-action/?client=${clientSlug}`);
    },
    assignUser(clientDetail) {
      this.clientSlug = clientDetail.slug;
      this.selectedClientAssignedUserData =
        (clientDetail.associated_users.length &&
          clientDetail.associated_users[0]) ||
        {};
      this.clientAssignedUserForm = true;
    },

    loadCre() {
      const creEndPoint = "/api/v1/users/autocomplete/?cre_user=True";
      this.$axios
        .$get(creEndPoint)
        .then((response) => {
          this.creList = response;
        })
        .catch((error) => this.formValidator.setError(error.response.data));
    },
    processFile(event) {
      this.importFile = event;
    },
    submitImport() {
      if (this.importFile) {
        this.loading = true;

        const importEndpoint = "/api/v1/crm/client-import";
        let formData = new FormData();
        formData.append("file", this.importFile);
        this.$axios
          .post(importEndpoint, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$store.dispatch("shell/showSnackbar", {
              text: `Successfully Imported Client Data!`,
              color: "green",
            });
            if (response.status == 201) {
              this.fetchDataTable();
            }
            this.loading = false;
            this.importDialog = false;
          })
          .catch((error) => {
            this.loading = false;
            this.formValidator.setError(error.response.data);
          });
      }
    },
    informationView(clientDetail) {
      this.showInformationView = true;
      this.clientSlug = clientDetail.slug;
    },
  },
};
</script>
<style scoped>
.is_blocked {
  font-size: 10px;
  color: red;
}
</style>
